/**
 * @generated SignedSource<<efa77f64ab22391c95489d6634a1f000>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type GraphQLJobTaskType = "AGENT" | "AGENT_DASHBOARD_SNAPSHOT" | "ALERT_INSIGHTS" | "ALERT_RESPONDER" | "ALERT_THREAD_LEARNING" | "AWS_MARKETPLACE_METERING" | "BITBUCKET_TOKEN_REFRESH" | "BUILDKITE_SYNC" | "CODE_PULL" | "CREDITS_COMPUTATION_V2" | "CTA_REMINDER" | "CUSTOMER_AGENT_IMAGE_BUILD" | "CUSTOMER_AGENT_SANDBOX_IMAGE_CACHE" | "CUSTOM_MCP_SERVER_TOOL_REFRESH" | "DAG_AGENT" | "DATABRICKS_MEMORY_INGESTION" | "DATABRICKS_SYNC" | "DATABRICKS_TO_POSTGRES_SYNC" | "DIGEST" | "GENERIC_LEARNING" | "GITHUB_CODEBASE_ANALYSIS" | "GITLAB_TOKEN_REFRESH" | "GRAFANA_CLOUD_DATASOURCE_SYNC" | "INCIDENT_CHANNEL_LEARNING" | "INCIDENT_DAG_AGENT" | "INCIDENT_KNOWLEDGE_SYNC" | "INGEST_SLACK_CHANNEL" | "NEWRELIC_APPLICATION_SYNC" | "ONBOARDING" | "ONBOARDING_QUESTION_TRAINING" | "PRODUCT_ANALYTICS" | "RESOURCE_FILES_SYNC" | "RESOURCE_SYNC_QUEUE" | "SLACK_CACHE_REFRESH" | "SLACK_USERGROUP_REFRESH" | "SNAPSHOT_CLEANUP" | "SUPPORT_AGENT_METRIC_CALCULATOR" | "SUPPORT_INSTRUCTION_GENERATION" | "TEAM_INSTRUCTION_GENERATION" | "WHAT_TIME_IS_IT_RIGHT_NOW" | "WORKFLOW_INVESTIGATION" | "WORKFLOW_MEMORY_CONSOLIDATION" | "WORKFLOW_MEMORY_EVAL_RECONCILER" | "%future added value";
export type Status = "ACTIVE" | "PAUSED" | "%future added value";
export type UpdateJobInput = {
  inputJson?: any | null | undefined;
  jobId: any;
  name: string;
  notificationIntegrationIds?: ReadonlyArray<any> | null | undefined;
  schedule?: any | null | undefined;
  slackChannelIds?: ReadonlyArray<string> | null | undefined;
};
export type UpdateJobMutation$variables = {
  input: UpdateJobInput;
};
export type UpdateJobMutation$data = {
  readonly updateJob: {
    readonly job: {
      readonly id: any;
      readonly inputJson: any;
      readonly latestPromptFeedback: {
        readonly id: any;
        readonly suggestions: ReadonlyArray<{
          readonly isStale: boolean;
          readonly name: string;
        }>;
      } | null | undefined;
      readonly name: string;
      readonly schedule: any | null | undefined;
      readonly status: Status;
      readonly taskType: GraphQLJobTaskType;
    };
  };
};
export type UpdateJobMutation = {
  response: UpdateJobMutation$data;
  variables: UpdateJobMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateJobPayload",
    "kind": "LinkedField",
    "name": "updateJob",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "GraphQLJob",
        "kind": "LinkedField",
        "name": "job",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "inputJson",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "schedule",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "taskType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "GraphQLPromptFeedback",
            "kind": "LinkedField",
            "name": "latestPromptFeedback",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "GraphQLPromptSuggestion",
                "kind": "LinkedField",
                "name": "suggestions",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isStale",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UpdateJobMutation",
    "selections": (v3/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UpdateJobMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "44759b9cd1e4f689fae7199013a7fba9",
    "id": null,
    "metadata": {},
    "name": "UpdateJobMutation",
    "operationKind": "mutation",
    "text": "mutation UpdateJobMutation(\n  $input: UpdateJobInput!\n) {\n  updateJob(input: $input) {\n    job {\n      id\n      name\n      inputJson\n      schedule\n      taskType\n      status\n      latestPromptFeedback {\n        id\n        suggestions {\n          name\n          isStale\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "b9d8247c9db998e4e80a6d6a23ab3296";

export default node;
